import { render, staticRenderFns } from "./PatientsFormMedical.vue?vue&type=template&id=7513deec&"
import script from "./PatientsFormMedical.vue?vue&type=script&lang=js&"
export * from "./PatientsFormMedical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports